define.alias("shared/components/shared/upgrade/bonus-features", "media/components/shared/upgrade/bonus-features");